import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";
import { TenementInsConfigInitFormResponseModel } from "../model/TenementInsConfigInitFormResponseModel";
import { TenementInsConfigFiltersInitFormResponseModel } from "../model/TenementInsConfigFiltersInitFormResponseModel";
import { TenementInsConfigInitFormModel } from "../model/TenementInsConfigInitFormModel";
import { TenementInsConfigInitModel } from "../model/TenementInsConfigInitModel";
import { TenementInsConfigInitWrapperModel } from "../model/TenementInsConfigInitWrapperModel";
import { TenementInstallmentConfigurationModel } from "../model/TenementInstallmentConfigurationModel";
import { InstallmentConfigurationTenementInitEditFormResponseModel } from "../model/InstallmentConfigurationTenementInitEditFormResponseModel";
import { TenementInsConfigDocumentModel } from "../model/TenementInsConfigDocumentModel";
import { RevertWtLstInItWrapper } from "../model/RevertWtLstInItWrapper";
import { SchemeEditorInItWrapper } from "../model/SchemeEditorInItWrapper";

@Injectable({
  providedIn: "root",
})
export class SchemeEditorService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  initPage() {
    return this.httpClient.get<{ lotteryList: { [key: number]: string }, status: string, errorMessage: string }>
    (ApiUrls.initLotteryEventForSchemeEditor);
  }

  initLotteryEventForSchemeEditor(page: number, size: number, lotteryKey?: number, filterText?: string){
    
    // let reqParams=
    //   `?page=${page}&size=${size}`;

    let reqParams=
      `?page=${page}&size=${size}`+
      (lotteryKey ? `&lotteryEventId=${lotteryKey}` : "") +
      (filterText ? `&filterText=${filterText}` : "");

    return this.httpClient.get<SchemeEditorInItWrapper>(
      ApiUrls.schemeEditorListFetchPageByFilterUrl + reqParams
    );
  }

  toggleActivationScheme(key: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationSchemeUrl.replace("{key}", key.toString()),
      {
        activeFlag,
      }
    );
  }
  
  toggleInActivationScheme(key: number, activeFlag: string, base64: string, reason: string) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationSchemeUrl.replace("{key}", key.toString()),
      {
        activeFlag, base64, reason
      }
    );
  }

  sendOtp(key: number) {
    return this.httpClient.get<{maskMobileNumber: string, status: string; errorMessage: string }>(
      ApiUrls.schemeInActiveSendOtpUrl.replace("{key}", key.toString())
    );
  }
  
  verifyOtp(key: string, otp : string) {
    return this.httpClient.post<{status: string; errorMessage: string }>(
      ApiUrls.schemeInActiveVerifyOtpUrl.replace("{key}", key),otp
      
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
